import { AxiosResponse } from "axios";

const errorHandler = (response?: AxiosResponse) => {
  const errorObj = {
    payload: 'There was a problem connecting to the server',
    status: response ? response.status : null
  };
  if (!response) {
    return errorObj;
  }
  switch (response.status) {
    case 400:
      errorObj.payload = 'The information provided is not valid';
      break;
    case 401:
      errorObj.payload = 'Unauthorized';
      break;
    case 403:
      errorObj.payload = 'There was an authentication error, maybe you should login again';
      break;
    case 404:
      errorObj.payload = 'The requested information was not found';
      break;
    case 413:
      errorObj.payload = 'The given request has exceed the allowed size';
      break;
    case 428:
      errorObj.payload = response.data;
      break;
    default:
      errorObj.payload = 'There was a problem connecting to the server';
  }

  return errorObj;
}

export default errorHandler;



// WEBPACK FOOTER //
// ./src/share/config/apiErrorHandler.ts